import { useState, useEffect } from 'react';
import { SoundEffects } from '../services/SoundEffects';

export const useSoundEffects = () => {
    const [soundEffects, setSoundEffects] = useState<SoundEffects | null>(null);
    const [soundEnabled, setSoundEnabled] = useState(true);

    useEffect(() => {
        const initSounds = () => {
            try {
                const sounds = new SoundEffects();
                setSoundEffects(sounds);
            } catch (error) {
                console.error('Failed to initialize sound effects:', error);
            }
        };
        initSounds();
    }, []);

    const playSuccess = () => {
        if (soundEnabled && soundEffects) {
            soundEffects.playSuccessSound();
        }
    };

    const playError = () => {
        if (soundEnabled && soundEffects) {
            soundEffects.playErrorSound();
        }
    };

    const playTyping = () => {
        if (soundEnabled && soundEffects) {
            soundEffects.playTypingSound();
        }
    };

    return {
        playSuccess,
        playError,
        playTyping,
        soundEnabled,
        setSoundEnabled
    };
};